"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconBellFilled = props => /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
  viewBox: "0 0 24 24",
  ...props,
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M10.01 20.76c0 1.1.89 1.99 1.99 1.99s1.99-.89 1.99-1.99H10.01ZM12 1.25c-.83 0-1.5.67-1.5 1.5v1.17C7.36 4.6 5 7.4 5 10.75v6l-2 2v1h18v-1l-2-2v-6c0-3.35-2.36-6.15-5.5-6.83V2.75C13.5 1.92 12.83 1.25 12 1.25Z"
  })
});
var _default = exports.default = (0, _withIcon.default)('IconBellFilled')(IconBellFilled);